import React, { useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Row, Button, Modal, Col, Input, Form, Upload, message, Table, Collapse } from "antd";
import AuthenticatedComponent from "./../AuthenticatedComponent";
import Template from "./../interfaz/Template.js";
import * as etiquetas from '../../ApplicationResources';
import { connect } from "react-redux";
import '../../css/modelStyle.css';
import HeaderModule from "../interfaz/Elements/HeaderModule";
import Menu from "../interfaz/Elements/Menu";
import { createStructuredSelector } from "reselect";
import { selectDistrito, selectEstado, selectProceso } from "../../redux/menu/menu-selectors";
import { selectCurrentUser } from "../../redux/user/user-selectors";
import ModalMensajes from "../interfaz/ModalMensajes";
import { Tree } from 'antd';
import 'antd/dist/antd.css';
import { SearchOutlined, UploadOutlined } from "@ant-design/icons";
import Tabla from "./Tabla.js";
import { verifiedToken } from '../../utils/funciones.js';

const { DirectoryTree } = Tree;
const { Panel } = Collapse;

class Administrador extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // States para el componente Tabla
      cEtiquetas: undefined,
      columnasCEtiquetas: undefined,
      cFechas: undefined,
      columnasCFechas: undefined,
      cParametros: undefined,
      columnasCParametros: undefined,
      cDescripcionEtiquetas: undefined,
      columnasCDescripcionEtiquetas: undefined,
      cDescripcionFechas: undefined,
      columnasCDescripcionFechas: undefined,
      cDescripcionParametros: undefined,
      columnasCDescripcionParametros: undefined,
      compulsaAutomatica : undefined,
      columnasCompulsaAutomatica : undefined,

      totalAspirantes: 0,
      aspirantesSinProcesoCompulsa: 0,
      aspirantesSinAcuseCompulsa: 0,
      aspirantesSinAcusePlatica: 0,
      aspirantesSinAcuseRecepcion: 0,
      aspirantesSinAcuseValidacion: 0,
      directorio: undefined,
      directorioAux: undefined,
      cargando: false,
      nombreCarpeta: "",
      // Propiedades que se leen del nodo seleccionado
      keyNodoSeleccionado: undefined,
      leafNodoSeleccionado: false,
      titleNodoSeleccionado: "",
      nodoSeleccionado: false,
      // Variables necesarias para el control de archivos
      fileList: [],
      uploading: false,
      // Variables necesarias para el componente ModalMensajes.jsx
      modalTipoMensaje: "",
      modalMensaje: "",
      modalAbrir: false,
      tipoModal: 0 // Almacena el último tipo de modal ejecutado o mostrado (revisar ApplicationResources: CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE, etc...)
    };
  }

  componentWillMount() {
    const { datosUsuario } = this.props;
    const rolUsuario = datosUsuario ? datosUsuario.rolUsuario : "";
    // Indica si el rol del usuario tiene permiso de administrador o no (true / false)
    const permisoAdministrador = etiquetas.rolesAdmin.includes(rolUsuario);

    if (!permisoAdministrador)
      this.props.history.push('/menuJDE');

    this.validarCombosProcesos();
  }

  componentDidUpdate(prevProps) {
    // Comparamos si el usuario ha seleccionado otro estado, proceso, distrito
    if (this.props.proceso !== prevProps.proceso
      || this.props.selectEstado !== prevProps.selectEstado
      || this.props.selectDistrito !== prevProps.selectDistrito) {
      this.validarCombosProcesos();

      return;
    }
  }

  /**
     * Función que permite obtener el listado de etiquetas
     * @returns 
     */
  obtenerEtiquetas = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerEtiquetas'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          ,'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cEtiquetas: datos,
          columnasCEtiquetas: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarEtiquetas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarEtiquetas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarEtiquetas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarEtiquetas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json', 
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
     * Función que permite obtener el listado de etiquetas
     * @returns 
     */
  obtenerFechas = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerFechas'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cFechas: datos,
          columnasCFechas: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarFechas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarFechas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarFechas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarFechas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
     * Función que permite obtener el listado de etiquetas
     * @returns 
     */
  obtenerParametros = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerParametros'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cParametros: datos,
          columnasCParametros: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarParametros = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarParametros", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarParametros = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarParametros", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
     * Función que permite obtener el listado de descripcion etiquetas
     * @returns 
     */
  obtenerDescripcionEtiquetas = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerDescripcionEtiquetas'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cDescripcionEtiquetas: datos,
          columnasCDescripcionEtiquetas: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarDescripcionEtiquetas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarDescripcionEtiquetas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarDescripcionEtiquetas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarDescripcionEtiquetas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }


  /**
     * Función que permite obtener el listado de descripción parámetros
     * @returns 
     */
  obtenerDescripcionParametros = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerDescripcionParametros'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cDescripcionParametros: datos,
          columnasCDescripcionParametros: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarDescripcionParametros = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarDescripcionParametros", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarDescripcionParametros = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarDescripcionParametros", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
     * Función que permite obtener el listado de descripción fechas
     * @returns 
     */
  obtenerDescripcionFechas = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerDescripcionFechas'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          cDescripcionFechas: datos,
          columnasCDescripcionFechas: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarDescripcionFechas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarDescripcionFechas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarDescripcionFechas = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarDescripcionFechas", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
     * Función que permite obtener el listado de descripción fechas
     * @returns 
     */
  obtenerCompulsaAutomatica = async () => {
    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerCompulsaAutomatica'
        , {
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        let datos = response.data.data
        let columnas = response.data.columns
        let contador = 1
        await datos.map(item => {
          item.key = contador
          contador++
        })

        this.setState({
          compulsaAutomatica: datos,
          columnasCompulsaAutomatica: columnas
        })
      }

    } catch (error) {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      return undefined
    }
  }

  /**
   * Función que permite guardar o actualizar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  guardarCompulsaAutomatica = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/guardarCompulsaAutomatica", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  /**
   * Función que permite eliminar la etiqueta especificada en el objeto json
   * @param {*} json 
   * @returns 
   */
  eliminarCompulsaAutomatica = async(json) => {
    return await axios.post(process.env.REACT_APP_API_URL +
      "/ws_reclutaseycae_central/ws/eliminarCompulsaAutomatica", json,
      {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("jwt-token") 
          }
      }
    )
  }

  obtenerInformacionAdministrador = async () => {
    const { proceso, selectDistrito, selectEstado } = this.props;
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = selectEstado ? selectEstado.idEstado : 0;
    const idDistrito = selectDistrito ? selectDistrito.idDistrito : 0;

    try {
      this.setState({ cargando: true });
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerInformacionAdministrador'
        , {
          idProcesoElectoral: idProcesoElectoral,
          idDetalleProceso: idDetalleProceso,
          idEstado: idEstado,
          idDistrito: idDistrito
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      this.setState({ cargando: false });

      if (response.data) {
        this.setState({
          totalAspirantes: response.data.totalAspirantes,
          aspirantesSinProcesoCompulsa: response.data.aspirantesSinProcesoCompulsa,
          aspirantesSinAcuseCompulsa: response.data.aspirantesSinAcuseCompulsa,
          aspirantesSinAcusePlatica: response.data.aspirantesSinAcusePlatica,
          aspirantesSinAcuseRecepcion: response.data.aspirantesSinAcuseRecepcion,
          aspirantesSinAcuseValidacion: response.data.aspirantesSinAcuseValidacion
        });
      }
    } catch (error) {
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  /**
   * Función que consulta la información del directorio especificado
   * @param {*} title Título del nodo (representa al nombre de la carpeta)
   * @param {*} key Campo que contiene la ruta del nodo seleccionado (ruta de carpeta)
   * @returns 
   */
  consultarDirectorio = async (title, key) => {
    try {
      this.setState({ cargando: true });
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerDirectorio'
        , {
          title: title,
          key: key,
          leaf: false
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      this.setState({ cargando: false });

      if (response.data) {
        if (this.state.directorio === undefined)
          this.setState({ directorio: response.data.directorio });
        else
          this.setState({ directorio: this.agregarNodo(this.state.directorio, response.data.directorio, key) });
      }
    } catch (error) {
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  /**
   * Función que crea una carpeta en el gluster
   * @param {*} key Nodo con la información de la ruta relativa de la carpeta a crear
   * @param {*} nombreCarpeta Nombre de la carpeta a crear
   * @returns 
   */
  crearCarpeta = async (key, nombreCarpeta) => {
    try {
      this.setState({ cargando: true });

      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/crearCarpeta'
        , {
          ruta: key,
          nombreCarpeta: nombreCarpeta
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      this.setState({ cargando: false });

      if (response.data)
        this.consultarDirectorio("", key);
    } catch (error) {
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  /**
   * Función que permite eliminar un archivo o directorio del servidor
   * @param {*} key Nodo que contiene la información del directorio o archivo a eliminar
   */
  eliminaCarpetaArchivo = async (key) => {
    try {
      this.setState({ cargando: true });

      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/eliminarDirectorioArchivo'
        , {
          rutas: key
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      this.setState({ cargando: false });

      if (response.data) {
        this.setState({ directorio: undefined });
        this.consultarDirectorio("ReclutaSEyCAE", "ReclutaSEyCAE");
      }

    } catch (error) {
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  /**
   * Función que agrega un nodo al árbol y key especificado
   * @param {*} arbol Objeto que representa al árbol
   * @param {*} nodo Objeto que será agregado al árbol y representa al nodo
   * @param {*} key Objeto que representa al nodo seleccionado donde será agregado el nodo
   * @returns 
   */
  agregarNodo = (arbol, nodo, key) => {
    const resultado = arbol.map((data, idx) => {
      let tempData = { ...data } // Copy object
      if (data.key === key) tempData.children = nodo // Set new field
      else if (data.children && data.children.length > 0)
        tempData.children = this.agregarNodo(data.children, nodo, key);
      return tempData
    });

    return resultado;
  }

  /**
   * Función que valida si el usuario ha seleccionado un proceso electoral y un distrito
   */
  validarCombosProcesos = async () => {
    const { proceso, selectDistrito } = this.props;
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idDistrito = selectDistrito ? selectDistrito.idDistrito : 0;

    // Si el usuario no ha seleccionado proceso o distrito, lo redireccionamos al menú principal
    if (idProcesoElectoral === 0 || idDetalleProceso === 0 /*|| idDistrito === 0*/)
      this.props.history.push('/menuJDE');
    else {
      // Si hay un cambio de distrito
      this.obtenerInformacionAdministrador();
      this.consultarDirectorio("ReclutaSEyCAE", "ReclutaSEyCAE");
      this.obtenerEtiquetas()
      this.obtenerFechas()
      this.obtenerParametros()

      this.obtenerDescripcionEtiquetas()
      this.obtenerDescripcionFechas()
      this.obtenerDescripcionParametros()

      this.obtenerCompulsaAutomatica()
    }
  }

  /**
   * Función que permite cerrar el modal
   */
  modalCerrar = () => {
    this.setState({ modalAbrir: false });
  }

  /**
   * Función que permite abrir el modal
   * @param {*} tipoMensaje Especificar el tipo de mensaje a desplegar (para saber qué tipo de imagen desplegar)
   * @param {*} mensaje Especificar el mensaje a desplegar
   * @param {*} tipoModal Elige el tipo de modal a desplegar (mensaje simple, decisión, etc...revisar el componente para mayor especificación)
   */
  modalAbrir = (tipoMensaje, mensaje, tipoModal) => {
    this.setState({
      modalTipoMensaje: tipoMensaje,
      modalMensaje: mensaje,
      modalAbrir: true,
      tipoModal: tipoModal
    });
  }

  /**
   * Función ligada al botón aceptar o sí, cuando se despliega el modal tipo confirmacion o tipo input text
   */
  modalConfirmacionBtnAceptarOnClick = async () => {
    if (this.state.tipoModal === etiquetas.CONSTANTE_MODAL_TIPO_MODAL_CONFIRMACION) {
      this.eliminaCarpetaArchivo(this.state.keyNodoSeleccionado);
      this.setState({ nodoSeleccionado: false, keyNodoSeleccionado: undefined });
    } else if (this.state.tipoModal === etiquetas.CONSTANTE_MODAL_TIPO_MODAL_INPUT_TEXT) {
      if (this.state.nodoSeleccionado)
        // Llamamos al ws para la creación de la carpeta
        this.crearCarpeta(this.state.keyNodoSeleccionado[0], this.state.nombreCarpeta);
      else {
        // Creamos la carpeta en la raíz
        this.crearCarpeta("ReclutaSEyCAE", this.state.nombreCarpeta);
        this.setState({ directorio: undefined });
        this.consultarDirectorio("ReclutaSEyCAE", "ReclutaSEyCAE");
      }

      this.setState({ nombreCarpeta: "" });
    }

    this.modalCerrar();
  }

  /**
   * Función ligada al modal, se ejecuta en el evento change del input text (para el tipo de modal input text)
   * @param {*} event Evento vinculado al evento change del input text del modal
   */
  modalInputTextOnChange = (event) => {
    this.setState({
      nombreCarpeta: event.target.value
    });
  }

  /**
   * Función que se ejecutar al seleccionar un nodo del componente tree
   * @param {*} keys Información de o los nodos seleccionados
   * @param {*} info Información completa del evento generado
   */
  onSelect = (keys, info) => {
    //console.log('Trigger Select', keys, info);
    if (keys.length >= 1)
      this.setState({ nodoSeleccionado: true, keyNodoSeleccionado: keys, leafNodoSeleccionado: info.node.props.leaf, titleNodoSeleccionado: info.node.props.title });
    else
      this.setState({ nodoSeleccionado: false, keyNodoSeleccionado: undefined });

    if (info.node.props.children && info.node.props.children.length === 0 && info.node.props.leaf === false
      && keys.length === 1) {
      this.consultarDirectorio("", keys[0]);
    }
  };

  onExpand = (keys, info) => {
    //console.log('Trigger Expand', keys, info);
  };

  btnEliminarOnClick = () => {
    this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ADVERTENCIA, "¿Está seguro?", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_CONFIRMACION);
  }

  btnCrearCarpetaOnClick = () => {
    this.modalAbrir(undefined, "Introduce el nombre de la carpeta", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_INPUT_TEXT);
  }

  handleUpload = () => {
    const formData = new FormData();
    this.state.fileList.forEach((file, index) => {
      formData.append('files', file);
    });

    // Construimos el json que será el parámetro necesario para la ruta donde se subirán los archivos
    const ruta = {
      ruta: this.state.nodoSeleccionado ? this.state.keyNodoSeleccionado[0] : "ReclutaSEyCAE"
    }

    formData.append('ruta', new Blob([JSON.stringify(ruta)], { type: "application/json" }));
    this.setState({ uploading: true });

    axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/subirArchivos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.getItem("jwt-token")
      }

    }).then(res => {
      if (this.state.nodoSeleccionado)
        this.consultarDirectorio("", this.state.keyNodoSeleccionado[0]);
      else {
        this.setState({ directorio: undefined });
        this.consultarDirectorio("ReclutaSEyCAE", "ReclutaSEyCAE");
      }

      this.setState({ fileList: [] });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION, "Los archivos se subieron satisfactoriamente", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }).catch(error => {
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }).finally(() => {
      this.setState({ uploading: false });
    });;
  }

  btnDescargarOnClick = async () => {
    try {
      this.setState({ cargando: true });
      const nombreArchivo = this.state.leafNodoSeleccionado ? this.state.titleNodoSeleccionado : this.state.titleNodoSeleccionado + ".zip";
      const tipoArchivo = this.state.leafNodoSeleccionado ? "application/download" : "application/zip";

      let hd = { 'Accept': 'application/json'
        ,'Content-Type': 'application/json'};

      hd = verifiedToken(hd);

      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/descargarArchivos'
        , {
          ruta: this.state.keyNodoSeleccionado[0]
        }, {
        responseType: 'blob',
        transformResponse: [data => {
          let blob = new window.Blob([data], { type: tipoArchivo });
          console.log(data);
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', nombreArchivo);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }],
        headers: hd
      }
      );

      this.setState({ cargando: false });
    } catch (error) {
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  actualizarAcusesEstadoDistrito = async (tipoAcuse) => {
    const { proceso, selectDistrito, selectEstado } = this.props;
    const idProcesoElectoral = proceso ? proceso.idProcesoElectoral : 0;
    const idDetalleProceso = proceso ? proceso.idDetalleProceso : 0;
    const idEstado = selectEstado ? selectEstado.idEstado : 0;
    const idDistrito = selectDistrito ? selectDistrito.idDistrito : 0;
    const idCorte = proceso ? proceso.corte : 0;

    try {
      this.setState({ cargando: true });
      const response = await axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/actualizarAcusesEstadoDistrito'
        , {
          idProcesoElectoral: idProcesoElectoral,
          idDetalleProceso: idDetalleProceso,
          idEstado: idEstado,
          idDistrito: idDistrito,
          idCorte: idCorte,
          tipoAcuse: tipoAcuse
        }, {
        headers: {
          'Accept': 'application/json'
          , 'Content-Type': 'application/json'
          , 'Authorization': localStorage.getItem("jwt-token") 
        }
      }
      );

      if (response.data) {
        // cargamos la información nuevamente
        this.validarCombosProcesos();
        this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION, "Los acuses se generaron satisfactoriamente", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
      }
      this.setState({ cargando: false });
    } catch (error) {
      console.log("ERROR", error);
      this.setState({ cargando: false });
      this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, "Ocurrió un error al cargar la información. Por favor vuelva a intentarlo más tarde.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
    }
  }

  render() {
    // Propiedades para el componente FileUpload
    const props = {
      multiple: true,
      onRemove: (file) => {
        // Se ejecuta cuando eliminamos un archivo
        const index = this.state.fileList.indexOf(file);
        const newFileList = this.state.fileList.slice();
        newFileList.splice(index, 1);
        this.setState({ fileList: newFileList });
      },
      beforeUpload: (file) => {
        if (this.state.fileList.filter(item => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified).length > 0) {
          this.modalAbrir(etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ADVERTENCIA, "El archivo seleccionado ya se ha cargado previamente, por favor seleccione otro archivo.", etiquetas.CONSTANTE_MODAL_TIPO_MODAL_MENSAJE_SIMPLE);
          return false;
        }
        // Se ejecuta cuando seleccionamos archivos para subirlos posteriormente
        var lista = this.state.fileList;
        lista.push(file);

        this.setState({ fileList: lista })
        return false;
      },
      ...this.state.fileList,
    };

    return (
      <AuthenticatedComponent>
        <Template
          contenido={
            <>
              <Menu />
              <div style={{ width: '100%' }}>
                <Row>
                  <Col sm={24} md={24} lg={24}>
                    <HeaderModule title={etiquetas.ETIQUETA_ADMINISTRADOR_TITULO_MODULO} redireccionar={'/menuJDE'} />
                  </Col>
                </Row>
                <Row>
                  <Col sm={20} md={20} lg={20} offset={2}>
                    {/* Aspirantes sin proceso de compulsa*/}
                    <Col sm={24} md={24} lg={24} className='administrador_registros_informativos'>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{etiquetas.ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_COMPULSA}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{this.state.aspirantesSinProcesoCompulsa + " de " + this.state.totalAspirantes}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          disabled={this.state.aspirantesSinProcesoCompulsa === 0}
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_PROCESO_COMPULSA)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_COMPULSA}
                        </Button>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                      </Col>
                    </Col>

                    {/* Aspirantes sin acuse pdf de compulsa*/}
                    <Col sm={24} md={24} lg={24} className='administrador_registros_informativos'>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{etiquetas.ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_COMPULSA}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{this.state.aspirantesSinAcuseCompulsa + " de " + (this.state.totalAspirantes)}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          disabled={this.state.aspirantesSinAcuseCompulsa === 0}
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_COMPULSA)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_GENERAR_ACUSES_FALTANTES}
                        </Button>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_COMPULSA)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_ACTUALIZAR_ACUSES}
                        </Button>
                      </Col>
                    </Col>

                    {/* Aspirantes sin acuse de cápsula de inducción*/}
                    <Col sm={24} md={24} lg={24} className='administrador_registros_informativos'>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{etiquetas.ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_PLATICA}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{this.state.aspirantesSinAcusePlatica + " de " + this.state.totalAspirantes}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_PLATICA)}
                          disabled={this.state.aspirantesSinAcusePlatica === 0}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_GENERAR_ACUSES_FALTANTES}
                        </Button>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_PLATICA)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_ACTUALIZAR_ACUSES}
                        </Button>
                      </Col>
                    </Col>

                    {/* Aspirantes sin acuse de recepción de documentos*/}
                    <Col sm={24} md={24} lg={24} className='administrador_registros_informativos'>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{etiquetas.ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_RECEPCION_DOCUMENTOS}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{this.state.aspirantesSinAcuseRecepcion + " de " + this.state.totalAspirantes}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_RECEPCION)}
                          disabled={this.state.aspirantesSinAcuseRecepcion === 0}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_GENERAR_ACUSES_FALTANTES}
                        </Button>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_RECEPCION)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_ACTUALIZAR_ACUSES}
                        </Button>
                      </Col>
                    </Col>

                    {/* Aspirantes sin acuse de validación de documentos*/}
                    <Col sm={24} md={24} lg={24} className='administrador_registros_informativos'>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{etiquetas.ETIQUETA_ADMINISTRADOR_LB_ASPIRANTES_SIN_ACUSE_VALIDACION_DOCUMENTOS}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <h1>{this.state.aspirantesSinAcuseValidacion + " de " + this.state.totalAspirantes}</h1>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_FALTANTES_VALIDACION)}
                          disabled={this.state.aspirantesSinAcuseValidacion === 0}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_GENERAR_ACUSES_FALTANTES}
                        </Button>
                      </Col>
                      <Col sm={6} md={6} lg={6}>
                        <Button type="primary"
                          onClick={() => this.actualizarAcusesEstadoDistrito(etiquetas.ADMINISTRADOR_EJECUTAR_GENERAR_ACUSES_TODOS_VALIDACION)}
                        >
                          {etiquetas.ETIQUETA_ADMINISTRADOR_BTN_EJECUTAR_ACTUALIZAR_ACUSES}
                        </Button>
                      </Col>
                    </Col>
                  </Col>

                  <Col sm={20} md={20} lg={20} offset={2} className="administrador_botones_archivos">
                    <Col sm={6} md={6} lg={6}>
                      <Button type="primary"
                        onClick={this.btnCrearCarpetaOnClick}
                        disabled={this.state.keyNodoSeleccionado && this.state.keyNodoSeleccionado.length > 1}
                      >
                        {etiquetas.general_btn_crear}
                      </Button>
                    </Col>
                    <Col sm={6} md={6} lg={6}>
                      <Upload {...props} fileList={this.state.fileList}>
                        <Button icon={<UploadOutlined />}>Seleccionar archivos</Button>
                      </Upload>
                      <Button
                        type="primary"
                        onClick={this.handleUpload}
                        disabled={this.state.fileList.length === 0 || (this.state.keyNodoSeleccionado && this.state.keyNodoSeleccionado.length > 1)}
                        loading={this.state.uploading}
                        style={{
                          marginTop: 16,
                        }}
                      >
                        {this.state.uploading ? 'Cargando...' : 'Comenzar carga'}
                      </Button>
                    </Col>
                    <Col sm={6} md={6} lg={6}>
                      <Button type="primary"
                        onClick={this.btnDescargarOnClick}
                        disabled={!this.state.nodoSeleccionado || (this.state.keyNodoSeleccionado && this.state.keyNodoSeleccionado.length > 1)}
                      >
                        {etiquetas.general_btn_descargar}
                      </Button>
                    </Col>
                    <Col sm={6} md={6} lg={6}>
                      <Button type="primary"
                        disabled={!this.state.nodoSeleccionado}
                        onClick={this.btnEliminarOnClick}
                      >
                        {etiquetas.general_btn_eliminar}
                      </Button>
                    </Col>
                  </Col>
                  <Col sm={20} md={20} lg={20} offset={2} className="administrador_visor_directorio">
                    <DirectoryTree
                      height={233}
                      multiple
                      onSelect={this.onSelect}
                      onExpand={this.onExpand}
                      treeData={this.state.directorio}
                    />
                  </Col>
                </Row>

                <Row style={{marginBottom:'20px', marginTop:'10px'}}>
                  <Col sm={20} md={20} lg={20} offset={2}>
                    <Collapse>
                      <Panel header="Catálogo descripción de parámetros" key="1">
                        <Tabla 
                          title={'C_DESCRIPCION_PARAMETROS'}
                          data={this.state.cDescripcionParametros} 
                          columns={this.state.columnasCDescripcionParametros} 
                          functionSave={this.guardarDescripcionParametros}
                          functionDelete={this.eliminarDescripcionParametros}
                        />
                      </Panel>
                      <Panel header="Catálogo de parámetros" key="2">
                        <Tabla 
                          title={'C_PARAMETROS'}
                          data={this.state.cParametros} 
                          columns={this.state.columnasCParametros} 
                          functionSave={this.guardarParametros}
                          functionDelete={this.eliminarParametros}
                        />
                      </Panel>
                      <Panel header="Catálogo de descripción de fechas" key="3">
                        <Tabla 
                          title={'C_DESCRIPCION_FECHAS'}
                          data={this.state.cDescripcionFechas} 
                          columns={this.state.columnasCDescripcionFechas} 
                          functionSave={this.guardarDescripcionFechas}
                          functionDelete={this.eliminarDescripcionFechas}
                        />
                      </Panel>
                      <Panel header="Catálogo de fechas" key="4">
                        <Tabla 
                          title={'C_FECHAS'}
                          data={this.state.cFechas} 
                          columns={this.state.columnasCFechas} 
                          functionSave={this.guardarFechas}
                          functionDelete={this.eliminarFechas}
                        />
                      </Panel>
                      <Panel header="Catálogo descripción de etiquetas" key="5">
                        <Tabla 
                          title={'C_DESCRIPCION_ETIQUETAS'}
                          data={this.state.cDescripcionEtiquetas} 
                          columns={this.state.columnasCDescripcionEtiquetas} 
                          functionSave={this.guardarDescripcionEtiquetas}
                          functionDelete={this.eliminarDescripcionEtiquetas}
                        />
                      </Panel>
                      <Panel header="Catálogo de etiquetas" key="6">
                        <Tabla 
                          title={'C_ETIQUETAS'}
                          data={this.state.cEtiquetas} 
                          columns={this.state.columnasCEtiquetas} 
                          functionSave={this.guardarEtiquetas}
                          functionDelete={this.eliminarEtiquetas}
                        />
                      </Panel>
                      <Panel header="Compulsa automática" key="7">
                        <Tabla 
                          title={'COMPULSA_AUTOMATICA'}
                          data={this.state.compulsaAutomatica} 
                          columns={this.state.columnasCompulsaAutomatica} 
                          functionSave={this.guardarCompulsaAutomatica}
                          functionDelete={this.eliminarCompulsaAutomatica}
                        />
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
              </div>
            </>
          }
          bloqueado={false}
          guia={false}
          cargando={this.state.cargando}
        >
        </Template>
        <ModalMensajes
          tipoMensaje={this.state.modalTipoMensaje}
          mensaje={this.state.modalMensaje}
          abrirModal={this.state.modalAbrir}
          cerrarModal={this.modalCerrar}
          tipoModal={this.state.tipoModal}
          btnAceptarOnClick={this.modalConfirmacionBtnAceptarOnClick}
          txtInputTextOnchange={this.modalInputTextOnChange}
          txtInputTextValue={this.state.nombreCarpeta}
        />
      </AuthenticatedComponent>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  proceso: selectProceso,
  datosUsuario: selectCurrentUser,
  selectDistrito: selectDistrito,
  selectEstado: selectEstado
});

export default withRouter(connect(mapStateToProps)(Administrador));